import { type ReactNode } from 'react'

import { type RecType } from '@/defs/rec'
import { type StatType } from '@/defs/stat'

import { StatRecColorId } from './StatRecColorId/StatRecColorId'
import { StatRecDeckFraction } from './StatRecDeckFraction/StatRecDeckFraction'
import { StatRecDeckTotal } from './StatRecDeckTotal/StatRecDeckTotal'
import { StatRecDeckTotalFull } from './StatRecDeckTotalFull/StatRecDeckTotalFull'
import { StatRecInclusion } from './StatRecInclusion/StatRecInclusion'
import { StatRecInclusionAddedCut } from './StatRecInclusionAddedCut/StatRecInclusionAddedCut'
import { StatRecInclusionGraphic } from './StatRecInclusionGraphic/StatRecInclusionGraphic'
import { StatRecLift } from './StatRecLift/StatRecLift'
import { StatRecRank } from './StatRecRank/StatRecRank'
import { StatRecReleaseDate } from './StatRecReleaseDate/StatRecReleaseDate'
import { StatRecSalt } from './StatRecSalt/StatRecSalt'
import { StatRecScore } from './StatRecScore/StatRecScore'
import { StatRecSpoilDate } from './StatRecSpoilDate/StatRecSpoilDate'
import { StatRecSynergy } from './StatRecSynergy/StatRecSynergy'
import { StatRecZScore } from './StatRecZScore/StatRecZScore'

type Props = {
  isInView?: boolean
  rec: RecType
  stat: StatType
}

type ConfigType = Record<StatType, ({ isInView, rec }: { isInView?: boolean; rec: RecType }) => ReactNode>

const CONFIG: ConfigType = {
  colorId: (props) => <StatRecColorId {...props} />,
  deckFraction: (props) => <StatRecDeckFraction {...props} />,
  deckTotal: (props) => <StatRecDeckTotal {...props} />,
  deckTotalCommander: (props) => <StatRecDeckTotal {...props} variant='commander' />,
  deckTotalFull: (props) => <StatRecDeckTotalFull {...props} />,
  inclusion: (props) => <StatRecInclusion {...props} />,
  inclusionAdded: (props) => <StatRecInclusionAddedCut {...props} variant='added' />,
  inclusionCut: (props) => <StatRecInclusionAddedCut {...props} variant='cut' />,
  inclusionGraphic: (props) => <StatRecInclusionGraphic {...props} />,
  lift: (props) => <StatRecLift {...props} />,
  rank: (props) => <StatRecRank {...props} />,
  released: (props) => <StatRecReleaseDate {...props} />,
  salt: (props) => <StatRecSalt {...props} />,
  scoreAdd: (props) => <StatRecScore {...props} variant='add' />,
  scoreCut: (props) => <StatRecScore {...props} variant='cut' />,
  spoiled: (props) => <StatRecSpoilDate {...props} />,
  synergy: (props) => <StatRecSynergy {...props} />,
  zScore: (props) => <StatRecZScore {...props} />,
}

export const StatRec = ({ isInView, rec, stat }: Props) => CONFIG[stat]({ isInView, rec })
